/**
 * PageContainer - 표준 페이지 컨테이너 컴포넌트
 *
 * 디자인 시스템에 따른 일관된 페이지 레이아웃 제공
 * - 전역 기준선: 헤더/검색/본문/푸터 모두 최대 1536px
 * - 모바일 16px, 태블릿 24px, 데스크톱 32px 여백
 */

import { cn } from "@/lib/utils";

export type ContainerSize = "read" | "default" | "wide";

interface PageContainerProps {
  children: React.ReactNode;
  size?: ContainerSize;
  className?: string;
}

const sizeClasses: Record<ContainerSize, string> = {
  read: "max-w-4xl",      // 읽기 중심 페이지 (뉴스, 상세)
  default: "max-w-[1536px]", // 목록은 넓게 사용해 필터 옆 결과 폭 확보
  wide: "max-w-[1536px]",    // 홈, 마켓과 동일한 전역 기준선
};

export function PageContainer({
  children,
  size = "default",
  className
}: PageContainerProps) {
  return (
    <div className={cn(
      "min-h-screen bg-background",
      className
    )}>
      <div className={cn(
        sizeClasses[size],
        "mx-auto w-full px-4 py-6 sm:py-8 md:px-6 lg:px-8 lg:py-10"
      )}>
        {children}
      </div>
    </div>
  );
}
